// extracted by mini-css-extract-plugin
export var faqListWrap = "faqList-legacy-module--faqListWrap--U7Mv6";
export var listHeader = "faqList-legacy-module--listHeader--TrP1D";
export var faqList = "faqList-legacy-module--faqList--4oUts";
export var faqBack = "faqList-legacy-module--faqBack--Xle7w";
export var faqSection = "faqList-legacy-module--faqSection--u81XU";
export var slideUp = "faqList-legacy-module--slideUp--LRBaQ";
export var slideUpLarge = "faqList-legacy-module--slideUpLarge--YGszn";